
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1058ab5f&scoped=true!stylus-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./item-double-line.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./item-double-line.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-1058ab5f!../../node_modules/vue-loader/lib/selector?type=template&index=0!./item-double-line.vue"),
  /* scopeId */
  "data-v-1058ab5f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/comps/item-double-line.vue
// module id = 754
// module chunks = 34